module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAZCAYAAABZ5IzrAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACPSURBVHgB7daxEYMwFANQKccAyRLQMQkFmSSrZI8UjJAtqBmBATiEzdFT2IWK/xq3Ov/7/wSYYdsOo7Q/YYDU2qR3Ih9w4ZPk4hhIC2w4ZQmhEnbd8JHwgoHzUqcwX5iQGJf6Vh7ZH3UQhUiuCKEQ+/7NbWtQap5/QgW5U09p0yw6de5D+WtGFi9sLXGp7x0haCNHJFJBQQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/m/menu-group.png
// module id = Cpp3
// module chunks = 1